let blockedUntil = 0;

const DEFAULT_BLOCK_MS = 350;
const MAX_BLOCK_MS = 2000;

function normalizeBlockDuration(durationMs: number) {
  if (!Number.isFinite(durationMs)) {
    return DEFAULT_BLOCK_MS;
  }

  const roundedDuration = Math.trunc(durationMs);
  return Math.min(Math.max(roundedDuration, 0), MAX_BLOCK_MS);
}

export function blockScheduleHubCardClick(durationMs = DEFAULT_BLOCK_MS) {
  const safeDuration = normalizeBlockDuration(durationMs);

  if (safeDuration === 0) {
    return;
  }

  const nextBlockedUntil = Date.now() + safeDuration;
  blockedUntil = Math.max(blockedUntil, nextBlockedUntil);
}

export function isScheduleHubCardClickBlocked() {
  const now = Date.now();

  if (now >= blockedUntil) {
    blockedUntil = 0;
    return false;
  }

  return true;
}
